<div class="mission-popups" *ngIf="visible.length">
  <div class="mission-popup" role="alert" *ngFor="let m of visible; trackBy: byId" (click)="show(m)">
    <ion-icon name="alert-circle" class="mission-popup-icon"></ion-icon>
    <div class="mission-popup-text">
      <strong>New mission</strong> <span class="mission-popup-time">{{ m.timestamp | date: "HH:mm" }}</span>
      <div class="mission-popup-summary">{{ summary(m.body) }}</div>
    </div>
    <ion-button fill="clear" aria-label="Dismiss" (click)="dismiss(m, $event)">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </div>
</div>
